// ALTIVEST Shopify: „Dodaj do torby” na PDP przez /cart/add.js (port pdp-cart.js z wersji żywej).
// Stan wyboru czyta z product.js (window.ALTIVEST_PRODUCT_STATE) i kroków wizarda (window.ALTIVEST_PDP_WIZARD).
// Czysta logika wyboru wariantu (testowana w Node: scripts/test_variant_pick.js).
// Zwraca {variant} albo {error}. Bez fallbacku na pierwszy wariant.
function avNorm(x) { return String(x == null ? '' : x).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ''); }
function avSame(a, b) {
  const A = avNorm(a); if (!A) return false;
  const rev = String(b == null ? '' : b).split(' · ').reverse().join(' · ');
  return A === avNorm(b) || A === avNorm(rev) || avNorm(String(a).split(' · ').reverse().join(' · ')) === avNorm(b);
}
function avPickVariant(variants, optionNames, sel) {
  const names = (optionNames || []).filter((n) => n !== 'Title');
  if (!variants || !variants.length) return { error: 'no-variants' };
  if (!names.length) return variants.length === 1 ? { variant: variants[0] } : { error: 'no-options' };
  const idx = (n) => (optionNames || []).indexOf(n) + 1;
  let pool = variants;
  for (const n of names) {
    const key = 'option' + idx(n);
    const values = Array.from(new Set(variants.map((v) => v[key])));
    const want = sel && sel[n];
    if (want) pool = pool.filter((v) => avSame(want, v[key]));
    else if (values.length === 1) pool = pool.filter((v) => v[key] === values[0]); // opcja z jedną wartością: jednoznaczna
    else return { error: 'missing-' + n };
  }
  if (pool.length !== 1) return { error: pool.length ? 'ambiguous' : 'no-match' };
  return pool[0].available === false ? { error: 'unavailable', variant: pool[0] } : { variant: pool[0] };
}
if (typeof module !== 'undefined' && module.exports) module.exports = { avPickVariant, avSame, avNorm };

(() => {
  'use strict';
  if (typeof document === 'undefined') return;
  const root = document.querySelector('.pdp-page[data-product-page]');
  const catalog = window.ALTIVEST_PRODUCT_DATA;
  if (!root || !catalog) return;
  const q = (s) => root.querySelector(s);
  const model = root.dataset.model;
  const product = catalog.products.find((p) => p.model === model);
  const button = q('[data-add]');
  if (!button) return;
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const variants = JSON.parse(root.dataset.variants || '[]');
  const optionNames = JSON.parse(root.dataset.options || '[]');
  const optionIds = JSON.parse(root.dataset.optionIds || '{}');
  const priced = parseInt(root.dataset.price || '0', 10) > 0;
  const doplataId = root.dataset.doplataId || '';
  const S = () => window.ALTIVEST_PRODUCT_STATE;
  const W = () => window.ALTIVEST_PDP_WIZARD;
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const title = root.dataset.nativeTitle || (product && (product.shortTitle || product.title)) || model;
  const stepName = { 1: 'kolor', 2: 'personalizację', 3: 'wzór lub napis', 4: 'rozmiar i ilość' };
  const rename = { 'Tekst haftu': 'Tekst', 'Krój pisma': 'Font', 'Kolor nici': 'Nić', 'Miejsce': 'Pozycja', 'Motyw': 'Wzór' };
  const errText = { 'unavailable': 'Ten wariant jest chwilowo niedostępny. Wybierz inny kolor lub rozmiar.', 'no-match': 'Nie znaleziono wariantu dla wybranego koloru i rozmiaru. Wybierz inne opcje lub skontaktuj się z nami.' };

  function keyFor(obj) {
    const s = JSON.stringify(obj); let h = 0x811c9dc5;
    for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) >>> 0; }
    return 'cfg-' + h.toString(16).padStart(8, '0');
  }
  function incomplete() {
    const w = W(); const s = S();
    if (!s) return 1;
    if (!s.textCheck || !s.textCheck.ok) return 3;
    if (w) return [1, 2, 3, 4].find((n) => !w.done(n)) || null;
    return s.missingFields && s.missingFields.length ? 1 : null;
  }
  function selection() {
    const d = (S() || {}).draft || {};
    const sel = {};
    if (d.color) sel.Kolor = d.color;
    if (d.size) {
  optionNames.forEach(function(name) {
    if (/^(rozmiar|rozmiary|size)$/i.test(name.trim())) {
      sel[name] = d.size;
    }
  });
}

    if (root.dataset.variantLabel) sel.Wariant = root.dataset.variantLabel;
    return sel;
  }
  function pick() { return avPickVariant(variants, optionNames, selection()); }
  async function remoteVariant() {
    // Liquid daje maks. 250 wariantów. Pełny wybór: Section Rendering API z ?option_values=<id wartości opcji>.
    const sel = selection(); const ids = []; const want = {};
    for (const n of optionNames) {
      if (n === 'Title') continue;
      const vals = optionIds[n] || {}; const w = sel[n]; if (!w) return null;
      const hit = Object.keys(vals).find((val) => avSame(w, val)); if (!hit) return null;
      ids.push(vals[hit]); want['option' + (optionNames.indexOf(n) + 1)] = hit;
    }
    const url = location.pathname.split('?')[0] + '?option_values=' + ids.join(',') + '&section_id=av-variant-id';
    const html = await (await fetch(url, { headers: { Accept: 'text/html' } })).text();
    const m = html.match(/<script type="application\/json" data-av-variant>([\s\S]*?)<\/script>/); if (!m) return null;
    const v = JSON.parse(m[1]);
    for (const [k, val] of Object.entries(want)) if (v[k] !== val) return null; // Shopify zwrócił inny wariant = brak takiej kombinacji
    return { id: v.id, availableForSale: v.available, price: Number(v.price) || 0 };
  }
  function variantId() { const r = pick(); return r.variant && !r.error ? r.variant.id : undefined; }
  function buildItem() {
    const s = S(); const d = s.draft;
    const props = {};
    for (const [k, v] of Object.entries(s.properties || {})) if (typeof v === 'string' && v && k !== '_cfg_preview_hash') props[rename[k] || k] = v;
    // Checkout: tylko informacje potrzebne klientowi. Bez „Brak”, bez technicznych pól i bez powtórzenia wariantu z tytułu.
    const vt = String((variants.find((v) => v.id === variantId()) || {}).title || '').toLowerCase();
    // Kolor, rozmiar i wariant niesie sam wariant Shopify; wzór i tekst to właściwości pozycji.
    const mid = (s.properties || {})._cfg_motif_id;
    if (mid) props._av_motif_id = String(mid);
    delete props.Kolor; delete props.Rozmiar;
    for (const k of Object.keys(props)) {
      const v = String(props[k] || '').trim();
      if (!v || /^(brak|nie|none|—|-)$/i.test(v) || /^(Personalizacja|Tryb)$/i.test(k) && /brak/i.test(v)) delete props[k];
      else if (/^Wariant$/i.test(k) && vt && vt.indexOf(v.toLowerCase()) >= 0) delete props[k];
      else if (!k.startsWith('_') && /^_?cfg|preview|hash|profil/i.test(k)) { props['_' + k] = props[k]; delete props[k]; }
    }
    props._av_model = model;
    const key = keyFor({ model, props });
    props._av_key = key;
    return { key, id: variantId(), quantity: d.quantity || 1, properties: props, text: !!(props.Tekst) };
  }

  const note = document.createElement('div'); note.className = 'pdp-cart-added'; note.dataset.cartAdded = ''; note.hidden = true;
  const noteText = document.createElement('p'); noteText.setAttribute('role', 'status'); noteText.setAttribute('aria-live', 'polite');
  const noteLink = document.createElement('a'); noteLink.href = R + 'cart'; noteLink.className = 'pdp-cart-added-link';
  note.append(noteText, noteLink);
  (q('.pdp-purchase') || button).after(note);
  const saleNote = document.getElementById('sale-note');
  if (saleNote) saleNote.hidden = true;
  button.removeAttribute('aria-describedby');

  let resetTimer = 0;
  function feedback(text, link) {
    note.hidden = false; noteText.textContent = text;
    noteLink.hidden = !link; if (link) noteLink.textContent = link;
    note.classList.remove('is-in'); if (!reduce()) { void note.offsetWidth; note.classList.add('is-in'); }
  }
  async function add() {
    const missing = incomplete();
    if (missing) {
      const w = W();
      if (w) { w.state.active = missing; w.render(false); }
      const st = root.querySelector('[data-wz-step="' + missing + '"]');
      st?.querySelector('.pdp-wz-head')?.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'instant' : 'smooth' });
      const target = st?.querySelector('[data-color-sample],[data-color-name],[data-color-defer],[data-mode],[data-text],[data-motif-id],[data-sizes] input,[data-quantity]');
      target?.focus({ preventScroll: true });
      feedback('Aby dodać do torby, wybierz ' + stepName[missing] + '.', '');
      return false;
    }
    const item = buildItem();
    if (!item.id) {
      // Liquid product.variants zwraca maks. 250 wariantów (T-shirt 459, bluzy 720). Brak na liście = dopytaj Shopify (Storefront API, bez tokenu).
      const r0 = pick();
      if (variants.length >= 250 && r0.error === 'no-match') {
        try { const v = await remoteVariant(); if (v && v.availableForSale !== false) item.id = Number(String(v.id).split('/').pop()); else if (v) { feedback(errText.unavailable, ''); return false; } } catch (e) { /* komunikat niżej */ }
      }
      if (!item.id) { feedback(errText[r0.error] || 'Nie można dodać tego produktu do torby. Skontaktuj się z nami.', ''); return false; }
    }
    // pkt 13: ostatnia bramka przed /cart/add.js: tekst haftu i wszystkie właściwości tekstowe przez filtr wulgaryzmów
    const TP = window.ALTIVEST_TEXT_POLICY;
    if (TP && [item.text].concat(Object.values(item.properties || {}).filter((v) => typeof v === 'string' && v.charAt(0) !== '_')).some((t) => t && !TP.check(t).ok && TP.check(t).code === 'TEXT_CONTENT_BLOCKED')) { feedback('Ten tekst narusza zasady dopuszczalnej treści. Zmień napis, aby dodać do torby.', ''); return false; }
    const items = [{ id: item.id, quantity: item.quantity, properties: item.properties }];
    if (item.text && doplataId && !(product && product.textIncluded)) items.push({ id: Number(doplataId), quantity: item.quantity, properties: { _av_for: item.key } });
    button.disabled = true;
    try {
      const r = await fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || '');
      const cart = await (await fetch(R + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const total = (cart.items || []).reduce((n, i) => n + (i.handle === 'altivest-doplata-tekst' ? 0 : i.quantity), 0);
      feedback('Dodano do torby: ' + title + ', ' + item.quantity + ' szt.', 'Zobacz torbę (' + total + ')');
      window.dispatchEvent(new CustomEvent('altivest:cart-change', { detail: { count: total } }));
      button.textContent = 'Dodano ✓'; button.classList.add('is-added');
      clearTimeout(resetTimer); resetTimer = setTimeout(() => { button.textContent = 'Dodaj do torby'; button.classList.remove('is-added'); }, 1800);
      return true;
    } catch (e) {
      feedback((e && e.message) || 'Nie udało się dodać do torby. Spróbuj ponownie.', '');
      return false;
    } finally { button.disabled = false; }
  }

  // Cena na stronie = cena wybranego wariantu (kolor + rozmiar). Bez wyboru: „od” najniższej ceny, gdy warianty mają różne ceny.
  const fmtPrice = (minor) => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(minor / 100);
  const priceEl = q('[data-price]');
  const SP = window.AV_SHOP_PRODUCT || {};
  const pMin = Number(SP.priceMin) || 0, pMax = Number(SP.priceMax) || 0;
  let priceSeq = 0, priceKey = '';
  function showPrice() {
    if (!priceEl || !priced) return;
    const sel = selection(); const key = JSON.stringify(sel);
    if (key === priceKey) return;
    priceKey = key;
    const seq = ++priceSeq;
    const base = () => { if (pMin && pMax && pMin !== pMax) priceEl.textContent = 'od ' + fmtPrice(pMin); };
    const r = pick();
    if (r.variant && Number(r.variant.price) > 0) { priceEl.textContent = fmtPrice(Number(r.variant.price)); return; }
    if (r.error === 'no-match' && variants.length >= 250) {
      base();
      remoteVariant().then((v) => { if (seq === priceSeq && v && v.price > 0) priceEl.textContent = fmtPrice(v.price); }).catch(() => {});
      return;
    }
    base();
  }
  function sync() {
    if (!priced) { button.disabled = true; return; }
    button.disabled = false;
    const status = q('[data-config-status]');
    if (status && /Zakup pozostaje niedostępny/.test(status.textContent)) status.textContent = incomplete() ? 'Uzupełnij wybór, aby dodać produkt do torby.' : '';
    root.dataset.cartReady = String(!incomplete());
    showPrice();
  }
  window.ALTIVEST_PDP_CART = { add, sync, buildItem, incomplete };
  if (!priced) {
    button.hidden = true;
    if (!q('[data-inquiry-cta]')) {
      const a = document.createElement('a'); a.className = 'btn btn-brass'; a.dataset.inquiryCta = '';
      a.href = R + 'pages/kontakt?produkt=' + encodeURIComponent(title); a.textContent = 'Zapytaj o wycenę';
      button.after(a);
    }
    return;
  }
  const pay = document.createElement('button'); pay.type = 'button'; pay.className = 'pdp-pay'; pay.dataset.pay = ''; pay.textContent = 'Zapłać';
  pay.addEventListener('click', async () => { if (await add()) location.assign(R + 'cart'); });  // 01.10: przez koszyk, gdzie jest wybór dostawy (InPost)
  button.after(pay);
  const panel = q('.pdp-panel') || root;
  ['click', 'input', 'change'].forEach((t) => panel.addEventListener(t, () => sync()));
  sync();
})();
